import React from "react";
import { useAtom } from "jotai";
import { aiConfirmState } from "./state.js";
import styles from "./AIConfirm.module.css";

const AIConfirmLayout = () => {
  const [state, _] = useAtom(aiConfirmState);
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <p className={styles.preLine}>{state.msg}</p>
        <div className={styles.privacyLink}>
          <input
            className={styles.checkbox}
            type="checkbox"
            checked={state.checked}
            onChange={state.handleChange}
          />
          <p className={styles.privacyLine} onClick={state.callPrivacy}>
            개인정보처리방침 동의{" "}
            <span className={styles.checkLine}>[확인하기]</span>
          </p>
        </div>
        <div className={styles.modalButtons}>
          <button className={styles.confirmButton} onClick={state.onConfirm}>
            확인
          </button>
          <button className={styles.cancelButton} onClick={state.onCancel}>
            취소
          </button>
        </div>
      </div>
    </div>
  );
};

const AIConfirm = React.memo(() => {
  const [state, _] = useAtom(aiConfirmState);
  return <>{state.isOpen && <AIConfirmLayout />}</>;
});

export default AIConfirm;

export const useAIConfirm = () => {
  const [state, setState] = useAtom(aiConfirmState);
  return () => {
    setState({
      ...state,
      isOpen: true,
      handleChange: () => {
        setState((s) => ({ ...s, checked: !s.checked }));
      },
    });
  };
};
